import { render, staticRenderFns } from "./EscalasFee.vue?vue&type=template&id=6c142c7d&"
import script from "./EscalasFee.vue?vue&type=script&lang=js&"
export * from "./EscalasFee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports